var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 499.98 499.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f0ee;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.03,0H36.95C16.55,0,0,16.04,0,35.82v428.36c0,19.78,16.55,35.8,36.95,35.8h426.09c20.4,0,36.95-16.02,36.95-35.8V35.82c0-19.78-16.55-35.82-36.95-35.82ZM151.94,418.42h-74.82v-225.09h74.82v225.09ZM114.55,162.6h-.48c-25.12,0-41.34-17.29-41.34-38.89s16.73-38.89,42.33-38.89,41.34,16.81,41.83,38.89c0,21.61-16.24,38.89-42.33,38.89ZM421.73,418.4h-74.82v-120.4c0-30.26-10.82-50.9-37.89-50.9-20.68,0-32.99,13.92-38.39,27.37-1.99,4.8-2.47,11.53-2.47,18.25v125.7h-74.82s.98-203.97,0-225.09h74.84v31.85c9.96-15.33,27.74-37.13,67.43-37.13,49.21,0,86.12,32.17,86.12,101.3v129.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.e1ea8bacc44fc4421fba770f053e9026.svg";
export { ForwardRef as ReactComponent };